import { render } from "./ResidentialContactForm.vue?vue&type=template&id=b06c93dc&scoped=true&ts=true"
import script from "./ResidentialContactForm.vue?vue&type=script&lang=ts"
export * from "./ResidentialContactForm.vue?vue&type=script&lang=ts"

import "./ResidentialContactForm.vue?vue&type=style&index=0&id=b06c93dc&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a2-CI\\_work\\63\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06c93dc"]])

export default __exports__